import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {DropdownButton, Button, MenuItem} from 'react-bootstrap';

import {makeRequest,dispatchAction,displayMessage}  from 'actions';
import config from  '../../../config';
import {FETCH_USERS,REMOVE_SELECTED_USERS,
    ADD_SELECTED_USERS, CLEAR_SELECTED_USERS} from "actions/actionTypes";
import AdminUsersSearchBox from 'dashboard/users/AdminUsersSearchBox'
import AdminUsersActionsBox from 'dashboard/users/AdminUsersActionsBox'
import AdminUserListTable from'dashboard/users/AdminUserListTable';
import PaginationBox from'shared/PaginationBox';

import queryString from 'query-string'

class AdminUsersPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
        this.state = {
            sortBy: '',
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) -1,
             selectAllRecords:false,
        };
    };
    componentWillMount() {
        if (!this.props.adminUsers.fetched) {
            var methodData = {
                "success_event": FETCH_USERS,
                'endpoint': '/users',
                'not_display_success_message': true,
            };

            this.props.makeRequest({}, methodData).catch(err => {
            });
        }
    }

    search(params = {},  ) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
          var queryParams = this.searchBox.getSearchParams();
         _.extend(queryParams, params);
        var methodData = {
            "endpoint": "/users",
            'not_display_success_message': true,
        };
        if (_.isUndefined(params.page)) { /* do not clear selected records when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_USERS)
        }
        if (queryParams.page ==1) {
            queryParams.page = undefined;
        }
        queryParams.lookup= ['SellerRecord','BuyerRecord']
        if (_.isUndefined(params.include)  ) {
            methodData['success_event'] = FETCH_USERS;
        }


        const stringified = queryString.stringify(_.omit(queryParams, ['include','addFields','page', 'lookup','all','sortBySecondary']));
         this.context.router.push(  '/admin/users?'  + stringified);
        return this.props.makeRequest(queryParams, methodData).then(response => {
            this.setState({pending:false})
            if (_.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            return response
        }).catch(err => {
            this.setState({pending:false})
            return Promise.reject(err)
        });
    }
    addUser() {
        window.open(config.getEnvironment().clientSideURL+`/admin/user/add`, "_blank")

    }

//     deleteUser(row) {
//     var methodData = {
//         "success_event": DELETE_SELLER,
//         type: 'delete',
//         endpoint: '/users/' + encodeURIComponent(row._id),
//         messageData: {'#1#': 'User'},
//         'success_event_data': {
//             'UserID': row._id
//         },
//         messageCode: 'recordDeleted',
//     };
//     self.props.makeRequest({}, methodData).catch(err => {
//     });
//
// }
    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({ selectAllRecords:true});
        }else{
            this.setState({ selectAllRecords:false});
        }
    }
    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.search()
        })
    }
    render() {
console.log('this.props.adminUsers.total', this.props.adminUsers.total  );
        if (this.props.adminUsers.total == 'initial'){
            return null
        }
        return (
            <div >
                {config.checkAccessRights.call(this,{ resources:['users_full']}) &&

                <AdminUsersActionsBox     {...this.props} ></AdminUsersActionsBox>
                }
                <AdminUsersSearchBox  pending={this.state.pending}   ref={(searchBox) => {
                    if (searchBox && !this.searchBox) {
                        this.searchBox = searchBox;
                        if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                            this.search()
                        }

                    }
                } }
                                     search={this.search.bind(this)}   selectAllRecords = {this.state.selectAllRecords} toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}    {...this.props} ></AdminUsersSearchBox>
                {config.checkAccessRights.call(this, {resources: [  'users_edit']}) &&
                <div className="bot5">
                    <Button onClick={(event) => this.addUser()} className="btn btn-primary">Add User</Button>
                </div>
                }
                {(this.props.adminUsers.total !== 'initial' && this.props.adminUsers.total == 0) ?
                    <div
                        className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Users')}</div> :
                    <div className="top20">
                        <AdminUserListTable
                            onSortChange={this.onSortChange.bind(this)} {...this.props}   ></AdminUserListTable>
                        <PaginationBox
                            ref={'pagination'}
                            currentPage={this.state.currentPage}
                            perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : undefined}
                              total={this.props.adminUsers.total == 'initial' ? 0 : this.props.adminUsers.total}
                            search={this.search.bind(this)}>
                        </PaginationBox>
                    </div>}

            </div >
        );

    }
}

function mapStateToProps(state) {
    return {'adminUsers': state.adminUsers,
        userReducer:state.userReducer};
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,dispatchAction,displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsersPage);
